var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistillationsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.002,
    height: 24.008,
    viewBox: "0 0 18.002 24.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#eef8ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.999)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(8 11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15,6.523V2h2V0H7V2H9V6.523a9,9,0,1,0,6,0ZM12,15a6.986,6.986,0,0,1-7,.083V15a6.994,6.994,0,0,1,6-6.92V2h2V8.08a6.993,6.993,0,0,1,6,6.837A6.986,6.986,0,0,0,12,15Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistillationsicon);
export default __webpack_public_path__ + "static/media/distillationsicon.8160152aa35b5e181980eea584fdf296.svg";
export { ForwardRef as ReactComponent };